<template>
    <div class="create-deal-page page pb-3 py-2">
        <div class="row m-0">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title">Deal</h4>
                </div>
            </div>
            <div class="card card-body">
                <deal
                    v-if="vehicle"
                    :vehicle="vehicle"
                    @updated="initVehicle()"
                    />
            </div>
        </div>
    </div>
</template>

<script>
import Deal from "@/components/main/Deal";
import Vehicle from "@/models/vehicle";
import VehicleUtils from "@/utils/vehicle";

export default {
    components: {
        Deal
    },
    data() {
        return {
            vehicle: null
        }
    },
    created() {
        this.initVehicle();
        },
        methods: {
            initVehicle() {
                Vehicle
                    .include(
                        'vehicleMake',
                        'transmission',
                        'body',
                        'condition',
                        'color',
                        'fuelType',
                        'numberOfDoors',
                        'drive',
                        'media',
                        'images',
                        'company',
                        'deals.buyer.companies',
                        'deals.seller.companies',
                    )
                    .params({
                        add_view: 1
                    })
                    .find(this.$route.params.vehicle_id)
                    .then((response) => {
                        this.vehicle = response;
                        VehicleUtils.arrangeVehicleImages(this.vehicle.images);
                    });
            },
        }
    }
</script>

<style scoped>

</style>
